import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Table, Typography, Row, Col, Card, Button, Tooltip } from 'antd'
import moment from 'moment'
import { Redirect } from 'react-router-dom'
import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined'
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const { Title } = Typography

const columns = [
    {
        title: 'Timestamp',
        dataIndex: 'timestamp',
        key: 'timestamp',
        sorter: (a, b) => moment(a.timestamp).unix() - moment(b.timestamp).unix(),
        sortDirections: ['descend'],
        defaultSortOrder: 'descend',
        width: '15%',
        render: (text) => {
            
            return(moment(text).format("MM-DD-YYYY hh:mm:ss A"))
        }
    },
    {
        title: 'Amendment of Articles of Incorporation to Increase Authorized Capital Stock',
        dataIndex: 'value',
        key: 'value',
        width: '20%',
    },
    {
        title: 'Name of Stockholder',
        dataIndex: 'fullname',
        key: 'fullname'
    },
    {
        title: 'Number of Shares',
        dataIndex: 'noOfShares',
        key: 'noOfShares'
    },
]

function Tabulation() {
    const [voters, setVoters] = useState(0)
    const [noVotes, setNoVotes] = useState(0)
    const [noShares, setNoShares] = useState(9)
    const auth = useSelector(state => state.auth)
    const users = useSelector(state => state.users)
    const votes = useSelector(state => state.votes)

    useEffect(() => {
        let nVoters = users.filter(user => user.isApproved === true).length
        let nVotes = votes.length
        let nShares = 0
        votes.map(vote => {
            if(vote.value) return nShares += parseInt(vote.noOfShares)
            return
        })
        
        setVoters(nVoters)
        setNoVotes(nVotes)
        setNoShares(nShares)
        
    }, [users])

    return (
        <div>
            {
                auth.isLoggedIn ? (
                    <>
                        <Title>Tabulation of Votes</Title>
                        <Row gutter={[16, 16]}>
                            <Col span={8}>
                                <Card style={{ padding: '16px 20px 8px'}} hoverable>
                                    <div className="card-chartTop">
                                        <div className="card-metaWrap">
                                            <div className="card-index-meta">
                                                <span>Total Number of Voters</span>
                                            </div>
                                            <div className="card-index-total">{voters}</div>
                                        </div>
                                    </div>
                                    <div className="card-index-footer">
                                        Approved Stockholders
                                    </div>
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card style={{ padding: '16px 20px 8px'}} hoverable>
                                    <div className="card-chartTop">
                                        <div className="card-metaWrap">
                                            <div className="card-index-meta">
                                                <span>Total Number of Votes</span>
                                            </div>
                                            <div className="card-index-total">{noVotes}</div>
                                        </div>
                                    </div>
                                    <div className="card-index-footer">
                                        Stockholders that voted
                                    </div>
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card style={{ padding: '16px 20px 8px'}} hoverable>
                                    <div className="card-chartTop">
                                        <div className="card-metaWrap">
                                            <div className="card-index-meta">
                                                <span>Total Number of Shares</span>
                                            </div>
                                            <div className="card-index-total">{noShares}</div>
                                        </div>
                                    </div>
                                    <div className="card-index-footer">
                                        Total shares of Stockholders that voted "Yes"
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                        <br />
                        <Table columns={columns} dataSource={votes} />
                        <ExcelFile element={<Button type='primary'>Export as Excel</Button>} filename="MCC 2021 Special Stockholders' Meeting - Tabulation of Votes">
                            <ExcelSheet data={votes} name="List of Votes">
                                <ExcelColumn label="Timestamp" value="timestamp" />
                                <ExcelColumn label="Amendment of Articles of Incorporation to Increase Authorized Capital Stock" value="value" />
                                <ExcelColumn label="Name of Stockholder" value="fullname" />
                                <ExcelColumn label="Number of Shares" value="noOfShares" />
                            </ExcelSheet>
                        </ExcelFile>
                    </>
                ) : (
                    <Redirect to="/" />
                )
            }
        </div>
    )
}

export default Tabulation
